import { Component, h } from 'preact'
import { Author } from '../Types'
import UserAvatar from '../../User/UserAvatar'
import UserName from '../../User/UserName'
import TopicVote from '../../topic-list-view/TopicVote'
import urlGenerator from '../../utils/urlGenerator'
import Axios from 'axios'

interface IdeaCardProps {
  title: string
  ideaId: string
  publicId: string
  author: Author
  votes: number
  voteSet: string[]
  isGuest: boolean
  currentUserId: number
}

interface State {
  votes: number
  currentUserVoted: boolean
}

class IdeaCard extends Component <IdeaCardProps, State> {
  constructor (props: IdeaCardProps) {
    super(props)
    this.state = {
      votes: props.votes,
      currentUserVoted: props.currentUserId !== null && props.voteSet.includes(props.currentUserId.toString())
    }
    this.toggleVoteStatus = this.toggleVoteStatus.bind(this)
  }

  async toggleVoteStatus () {
    if (this.props.isGuest) {
      const event = new CustomEvent('GuestUserAction')
      window.dispatchEvent(event)
      return
    }

    if (this.state.currentUserVoted) {
      this.setState({ currentUserVoted: false, votes: this.state.votes - 1 })
      await Axios.post(`/community/api/ideas/${this.props.ideaId}/unvote`)
    } else {
      this.setState({ currentUserVoted: true, votes: this.state.votes + 1 })
      await Axios.post(`/community/api/ideas/${this.props.ideaId}/vote`)
    }
  }

  render ({ publicId, title, author }: IdeaCardProps, { votes, currentUserVoted }: State) {
    return (
      <div className='pipeline__idea-wrapper'>
        <span className='pipeline__idea-title'>
          <a href={urlGenerator('ideas', title, publicId)}>{title}</a>
        </span>
        <div className='pipeline__idea-meta-info'>
          <div style='display: flex; align-items: center;'>
            <UserAvatar
              user={{ ...author, ...{ name: author.username } }}
              extraClass='avatar avatar--S'
              showRank
              disablePopup
            />
            <UserName user={{ ...author, ...{ name: author.username } }} extraClass='pipeline__idea-username' />
          </div>
          <TopicVote
            currentUserVoted={currentUserVoted}
            numberOfVotes={votes}
            onClick={this.toggleVoteStatus}
          />
        </div>
      </div>
    )
  }
}

export default IdeaCard
